export const PublicRoutesType = {
  home :{
    rel : "/",
    abs : "/"
  },
  about :{
    rel : "about",
    abs : "/about"
  },
  login :{
    rel : "login",
    abs : "/login"
  },
  others :{
    rel : "*",
    abs : "/*"
  },
}
